import { NgModule } from '@angular/core';
import { Routes, RouterModule} from '@angular/router';
import { Page404Component } from './content/page404/page404.component';
import { MainAreaComponent } from './content/main-area/main-area.component';
import { ContentService } from './services/content.service'

const contentService:ContentService = new ContentService();
const pages = contentService.getAllRouteNames();
const routes: Routes = [];

routes.push({ path: '', component: MainAreaComponent});
for(const page of pages) {
  routes.push({ path: page, component: MainAreaComponent });
}
routes.push({ path: '**', component: Page404Component });
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
